import { useIntl } from 'react-intl';
import useQueryApiClient from '../../../../utils/useQueryApiClient';
import { useState } from 'react';
import { Divider, Checkbox } from '../../../../ui';
import { StyledBusinessTab } from '../style';
import { useAuth } from 'hooks/useAuth';

interface ServiceProps {
  value: number;
  label: string;
}

interface QmarksProps {
  value: number;
  label: string;
}

export const AdditionalInformation = () => {
  const [services, setServices] = useState<ServiceProps[]>([]);
  const [qmarks, setQmarks] = useState<QmarksProps[]>([]);
  const intl = useIntl();
  const { user } = useAuth();

  useQueryApiClient({
    request: {
      url: '/api/v2/filters/services',
    },
    onSuccess: (response) => handleSuccessServicesFetch(response),
  });

  useQueryApiClient({
    request: {
      url: `/api/v2/farms/qmarks/${user?.farmId}`,
    },
    onSuccess: (response: QmarksProps[]) => handleSuccessQmarksFetch(response),
    enabled: !!user?.farmId,
  });

  const handleSuccessServicesFetch = (response: ServiceProps[]) => {
    if (Array.isArray(response)) {
      response.sort((a, b) => a.label.localeCompare(b.label));
      setServices(response);
    }
  };

  const handleSuccessQmarksFetch = (response: QmarksProps[]) => {
    setQmarks(response);
  };

  return (
    <StyledBusinessTab>
      <div className={'content'}>
        <div className={'section'}>
          <div className={'title'}>
            <h3>{intl.formatMessage({ id: 'general.additional_options' })}</h3>
          </div>
          <div className={'double-column-checkbox-two-sixteen'}>
            <Checkbox options={services} name={'services'} />
          </div>
        </div>
        <Divider />
        <div className={'section'}>
          <div className={'title'}>
            <h3>{intl.formatMessage({ id: 'navigation.qmark' })}</h3>
          </div>
          <div className={'double-column-checkbox-two-sixteen'}>
            <Checkbox options={qmarks} name={'quality_marks'} disabled={true} />
          </div>
        </div>
      </div>
    </StyledBusinessTab>
  );
};
